module.exports = new __parcel__URL__("open_chest_button.8efb6e0b.png").toString();